// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
:host ::ng-deep .customCell {
  width: 150px !important;
}

:host ::ng-deep .checkboxgrid {
  width: 100px !important;
}

.tickmark {
  font-size: 20px;
  color: green;
  display: none;
}

.test {
  background: blue;
}

.basepadding {
  padding-bottom: 30px;
}

.sidepadding {
  padding-left: 15px;
  margin-right: -20px;
}

.modal-body {
  height: 250px !important;
  overflow-y: scroll !important;
}

.save-changes {
  width: 100% !important;
}

table tr th, table tr td {
  width: 45% !important;
}

.errmsg {
  color: red;
}

.scrollbar {
  overflow-y: scroll;
  height: 500px;
}

.scrollbar::-webkit-scrollbar {
  width: 7px;
  border-radius: 6px;
  background: #D0D0D0 0% 0% no-repeat padding-box;
}

.scrollbar::-webkit-scrollbar-thumb {
  background: #0068AE 0% 0% no-repeat padding-box;
  border-radius: 6px;
}

.download-button {
  float: right;
  margin-top: 30px;
  width: 266px;
  height: 42px;
  background: #1483D9 0% 0% no-repeat padding-box;
  border: 1px solid #1A84D8;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #FFFFFF;
  margin-left: 20px;
  margin-bottom: 32px;
}

textarea {
  border-color: #cccccc;
  border-radius: 6px;
  min-height: 60px !important;
  margin: 3px 0;
  width: 98%;
  font: 16px "Omnes-ATT-W02";
  color: #191919;
  box-shadow: inset 0px 2px 0px 0px rgba(0, 0, 0, 0.08);
}
textarea:focus {
  outline: none !important;
  border: 1px solid #0568ae;
}

.actions {
  width: 285px;
  height: 42px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-d1d2d3);
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D1D2D3;
  border-radius: 5px;
  opacity: 1;
  color: #979797;
}

.apply-button {
  margin-left: 5px;
  width: auto;
  height: 42px;
  background: transparent linear-gradient(180deg, #F1F2F3 0%, #FAFBFC 100%) 0% 0% no-repeat padding-box;
  border: 1px solid #D0D1D2;
  border-radius: 6px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #0068AE;
  display: inline-flex;
}

.apply-button:hover {
  background: none;
}

.apply-button:focus {
  background: none;
}

.textarea-container {
  position: relative;
}

.textarea-container button {
  position: absolute;
  bottom: 10px;
  right: 23px;
}

.textarea-container textarea {
  display: block;
}

@media (max-width: 1024px) {
  .download-button {
    margin-top: 10px;
    width: auto;
  }
  .apply-button {
    margin-left: 5px;
    width: auto !important;
  }
}
.guide-text {
  font-size: 15px;
}

.hideAction {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/care/deviceSubmissionTracking/device-submission-tracking.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA1IA;EACE,uBAAA;AA4IF;;AA1IA;EACE,uBAAA;AA6IF;;AA3IA;EACC,eAAA;EACC,YAAA;EACA,aAAA;AA8IF;;AA5IA;EACE,gBAAA;AA+IF;;AA5IA;EACE,oBAAA;AA+IF;;AA5IA;EACE,kBAAA;EACA,mBAAA;AA+IF;;AA5IA;EACE,wBAAA;EACA,6BAAA;AA+IF;;AA7IA;EACE,sBAAA;AAgJF;;AA9IA;EACE,qBAAA;AAiJF;;AA/IA;EACE,UAAA;AAkJF;;AAhJA;EACE,kBAAA;EACA,aAAA;AAmJF;;AAhJA;EACE,UAAA;EACA,kBAAA;EACA,+CAAA;AAmJF;;AAhJA;EACE,+CAAA;EACA,kBAAA;AAmJF;;AAhJE;EACE,YAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AAmJJ;;AAhJE;EACE,qBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,UAAA;EACA,0BAAA;EACA,cAAA;EACA,qDAAA;AAmJJ;AAjJI;EACE,wBAAA;EACA,yBAAA;AAmJN;;AA9IE;EACE,YAAA;EACA,YAAA;EACA,mEAAA;EACA,6CAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAiJJ;;AA7IE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qGAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AAgJJ;;AA9IE;EACE,gBAAA;AAiJJ;;AA/IE;EACE,gBAAA;AAkJJ;;AAnIE;EAEE,kBAAA;AAqIJ;;AAlIE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAqIJ;;AAlIE;EACE,cAAA;AAqIJ;;AFrQI;EEoIA;IACE,gBAAA;IACA,WAAA;EAqIJ;EAlIE;IACE,gBAAA;IACA,sBAAA;EAoIJ;AACF;AAhIE;EACE,eAAA;AAkIJ;;AA/HE;EACE,kBAAA;AAkIJ","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n// :host ::ng-deep .checkboxcol {\n//   width : 100px!important;\n//  }\n \n//  :host ::ng-deep .customCell {\n//   min-width: 100px;\n// }\n:host ::ng-deep .customCell {\n  width: 150px!important;\n}\n:host ::ng-deep .checkboxgrid{\n  width: 100px!important;\n}\n.tickmark{\n font-size:20px;\n  color:green;\n  display:none;\n}\n.test {\n  background: blue;\n}\n\n.basepadding {\n  padding-bottom: 30px;\n}\n\n.sidepadding {\n  padding-left: 15px;\n  margin-right: -20px;\n}\n\n.modal-body{\n  height:250px!important;\n  overflow-y: scroll !important;\n}\n.save-changes{\n  width:100%!important;\n}\ntable tr th, table tr td {\n  width: 45%!important;\n}\n.errmsg{\n  color:red;\n}\n.scrollbar{\n  overflow-y: scroll;\n  height: 500px;\n}\n\n.scrollbar::-webkit-scrollbar {\n  width: 7px;\n  border-radius: 6px;\n  background: #D0D0D0 0% 0% no-repeat padding-box;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n  background: #0068AE 0% 0% no-repeat padding-box;\n  border-radius: 6px;\n}\n\n  .download-button{\n    float: right;\n    margin-top:30px;\n    width: 266px;\n    height: 42px;\n    background: #1483D9 0% 0% no-repeat padding-box;\n    border: 1px solid #1A84D8;\n    border-radius: 6px;\n    opacity: 1;\n    text-align: center;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    margin-left:20px;\n    margin-bottom: 32px;\n  }\n\n  textarea {\n    border-color: #cccccc;\n    border-radius: 6px;\n    min-height: 60px!important;\n    margin: 3px 0;\n    width: 98%;\n    font: 16px 'Omnes-ATT-W02';\n    color: #191919;\n    box-shadow: inset 0px 2px 0px 0px rgba(0, 0, 0, 0.08);\n\n    &:focus {\n      outline: none !important;\n      border: 1px solid #0568ae;\n      // -webkit-appearance:none;\n    }\n  }\n\n  .actions{\n    width: 285px;\n    height: 42px;\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    border: 1px solid var(--unnamed-color-d1d2d3);\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #D1D2D3;\n    border-radius: 5px;\n    opacity: 1;\n    color: #979797;\n  }\n \n\n  .apply-button{\n    margin-left: 5px;\n    width: auto;\n    height: 42px;\n    background: transparent linear-gradient(180deg, #F1F2F3 0%, #FAFBFC 100%) 0% 0% no-repeat padding-box;\n    border: 1px solid #D0D1D2;\n    border-radius: 6px;\n    opacity: 1;\n    text-align: center;\n    letter-spacing: 0px;\n    color: #0068AE;\n    display: inline-flex;\n  }\n  .apply-button:hover{\n    background: none;;\n  }\n  .apply-button:focus{\n    background: none;;\n  }\n  // .textarea-container {\n  //   position: relative;\n  // }\n  // .textarea-container textarea {\n  //   width: 100%;\n  //   height: 100%;\n  //   box-sizing: border-box;\n  // }\n  // .textarea-container button {\n  //   position: absolute;\n  //   top: 0;\n  //   right: 0;\n  // }\n  .textarea-container{\n   // display:inline-block;\n    position:relative;\n  }\n  \n  .textarea-container button{\n    position:absolute;\n    bottom:10px;\n    right:23px;\n  }\n  \n  .textarea-container textarea{\n    display:block;\n  }\n  @include respond-to(small) {\n\n    .download-button{\n      margin-top:10px;\n      width: auto;\n    }\n \n    .apply-button{\n      margin-left: 5px;\n      width: auto!important;\n    }\n\n  }\n\n  .guide-text {\n    font-size: 15px;\n  }\n\n  .hideAction {\n    visibility: hidden;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
